import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import JotformReviews from "@/components/site/JotformReviews";

const GOOGLE_URL = "https://share.google/5Kq1PoJmj8ulZW6hO";

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="noise relative overflow-hidden border-y border-[#282C34] bg-[#14171C] py-28 sm:py-36"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute -right-20 top-1/2 -translate-y-1/2 select-none font-display text-[26rem] leading-none text-[#0B0C0E]/60"
      >
        GW
      </div>

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono-ind text-xs uppercase tracking-[0.3em] text-[#FF9F00]">
            Word on the Street
          </p>
          <h2 className="mt-4 max-w-3xl font-display text-5xl leading-[0.95] tracking-tight sm:text-7xl">
            PAYNE COUNTY
            <br />
            <span className="text-stroke-orange">RATES US ON</span>{" "}
            <span className="text-[#FF5A00]">GOOGLE</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-12">
          <p className="max-w-md text-sm leading-relaxed text-zinc-400 sm:text-base">
            Fast response times, fair pricing, and friendly service you can trust
            — that's what our neighbors in Cushing and Stillwater say about us.
            Our live Google review feed is below, updating automatically as new
            reviews come in.
          </p>
        </Reveal>

        <Reveal delay={0.2} className="mt-14 border border-[#282C34] bg-[#0B0C0E]/70 p-6 backdrop-blur sm:p-10">
          <JotformReviews />
        </Reveal>

        <Reveal delay={0.15} className="mt-10 flex flex-wrap gap-4">
          <a
            href={GOOGLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-google-link"
            className="group inline-flex items-center gap-3 bg-[#FF5A00] px-8 py-4 font-display text-xl tracking-widest text-[#0B0C0E] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#FF9F00]"
          >
            READ OUR GOOGLE REVIEWS
            <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
          <a
            href={GOOGLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-leave-review-link"
            className="inline-flex items-center gap-3 border border-zinc-600 px-8 py-4 font-display text-xl tracking-widest text-zinc-100 transition-colors duration-300 hover:border-[#FF5A00] hover:text-[#FF9F00]"
          >
            LEAVE US A REVIEW
          </a>
        </Reveal>
      </div>
    </section>
  );
}
